<ngb-tabset #tabs="ngbTabset">
  <ngb-tab id="app-versions" (select)="selectedTab = 'app-versions';" title="{{'App version list' | translate}}">
    <ng-template ngbTabContent>
      <div class="wrapper">
        <div class="container">
          <ngb-accordion [closeOthers]="true" *qmLoading="appVersions">
            <ngb-panel [id]="version.id" [title]="version.versionNumber" *ngFor="let version of appVersions.data">
              <ng-template ngbPanelContent>
                <div class="list-group list-group-flush">
                  <div class="list-group-item flex-column align-items-start">
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">{{'Edit app update' | translate}}</h5>
                    </div>
                    <p class="mb-1">
                      <button class="btn btn-outline-info" (click)="editUpdate(version); tabs.select('new-app-version')">{{'Edit' | translate}}</button>
                    </p>
                  </div>
                  <div class="list-group-item flex-column align-items-start">
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">{{'App update description' | translate}}</h5>
                    </div>
                    <p class="mb-1 line-breaker">
                      {{version.generalDescription}}
                    </p>
                  </div>
                  <ng-container>
                    <div class="list-group-item flex-column align-items-start" *ngIf="version.vivoDescription">
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">{{'VIVO updates description' | translate}}</h5>
                      </div>
                      <p class="mb-1 line-breaker">
                        {{version.vivoDescription}}
                      </p>
                    </div>
                  </ng-container>
                  <div class="list-group-item flex-column align-items-start">
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">{{'App version number' | translate}}</h5>
                    </div>
                    <p class="mb-1">
                      {{version.versionNumber}}
                    </p>
                  </div>
                  <div class="list-group-item flex-column align-items-start"
                       *ngFor="let tenant of version.tenantSpecificDescription">
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">{{'Tenant' | translate}}: {{tenant.tenantId}}</h5>
                    </div>
                    <p class="mb-1 line-breaker">
                      {{tenant.description}}
                    </p>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
      </div>
    </ng-template>
  </ngb-tab>
  <ngb-tab id="new-app-version" (select)="selectedTab = 'new-app-version'" title="{{'New app version' | translate}}">
    <ng-template ngbTabContent>
      <div class="wrapper">
        <div class="container">
          <qm-dynamic-form *ngIf="formName && fields" (formSubmit)="formSubmit($event)" (formData)="formChanged($event)"
                           [fields]="fields" [formName]="formName" [horizontal]="true"></qm-dynamic-form>
        </div>
      </div>
    </ng-template>
  </ngb-tab>
</ngb-tabset>

<i class="far fa-pen" data-fa-symbol="edit-version"></i>
